module.exports = __webpack_public_path__ + "img/pmsm3_.8590efae.png";